import { SvgIcon } from '@material-ui/core';
import React, { useState } from 'react'
import TooltipHLPure from '../tooltipHL/tooltipHL.pure';
import { useTranslation } from 'react-i18next';

const PasswordInputPure = (props) => {
    const { t } = useTranslation();
    const { label, showTooltip } = props;
    const [showPassword, setShowPassword] = useState(false)
    const toggleViewPassword = () => setShowPassword(prev => !prev)

    return <div className='passwordInputPure'>
        <div className='loginForm-label-tooltip'>
            <label htmlFor={props.id} className="loginForm-input-label">{label}</label>
            {
                showTooltip &&
                <TooltipHLPure
                    titleTooltip={t("loginView.passwordTooltipTitle")}
                    freeContent={(
                        <ul className='loginForm-label-tooltip-content'>
                            <li>{t("loginView.passwordTooltipDesc1")}</li>
                            <li>{t("loginView.passwordTooltipDesc2")}</li>
                            <li>{t("loginView.passwordTooltipDesc3")}</li>
                            <li>{t("loginView.passwordTooltipDesc4")}</li>
                        </ul>
                    )}
                    informationIcon
                />
            }
        </div>
        <div className='loginForm-input-wrapper'>
            <input
                maxLength={100}
                type={showPassword ? "text" : "password"}
                className="loginForm-input-field loginForm-input-password"
                {...props}
            />

            {/* EYE ICON */}
            <button className='loginForm-showPasswordBtn' onClick={toggleViewPassword}>
                <SvgIcon
                    className={`loginForm-input-icon ${showPassword ? "login-input-show-password-icon-active" : "login-input-show-password-icon-desactive"}`}
                >
                    <path d="M0 0h24v24H0V0z" fill="none" />
                    <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
                </SvgIcon>
            </button>
        </div>
    </div>
}

export default PasswordInputPure